export default __webpack_public_path__ + "static/media/dashboard-person-icon.a049d396.svg";